<template>
  <div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <div class="button" @click="clickPreview">미리보기</div>
      <div class="button is-primary" @click="saveData">저장하기</div>
    </div>

    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="팝업 등록/수정">
            <div class="columns is-multiline">
              <div class="column is-5">
                <admin-form-item label="팝업 제목*">
                  <input class="input"
                        :value="popup.title"
                        @input="e => popup.title = e.target.value"
                        placeholder="팝업 제목을 입력하세요."
                        type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="팝업 이미지" :desc="ratio_desc">
                  <div v-for="(img, idx) in popup.imgs" :key="'popup-'+idx" class="flex align-center">
                    <input-img style="display: inline-block;" :key="'img'+idx"
                               class="item"
                               :idx="(idx+1)*111154"
                               @addImg="popup.imgs.push('')"
                               :url.sync="popup.imgs[idx]"></input-img>
                    <input class="input"
                           :value="linkValue(idx)"
                           @input="e=>inputLink(e, idx)"
                           placeholder="팝업를 누르면 이동할 경로를 입력해주세요."
                           type="text">
                    <i v-if="idx > 0" class="material-icons btn-del" @click="onDelete(idx)">close</i>
                  </div>
                  <div class="lp-add-img" @click="addImg">
                    <i class="material-icons">add</i>
                  </div>
                </admin-form-item>
              </div>
              <!-- 비율 사용 X -->
              <!-- <div class="column is-full">
                <admin-form-item label="이미지 비율" desc="최대 이미지 크기는 가로,세로 1920이며, 이미지 비율에 맞게 업로드를 권장합니다.
                 ex) 4:3 비율은 1920:1440, 16:9 비율은 1920:1080, 2.35:1 비율은 1920: 817, 4:1 비율은 1920:480">
                  <lp-radio :val.sync="popup.ratio"
                            value_name="value"
                            label_name="label"
                            :data="ratioArr"></lp-radio>
                </admin-form-item>
              </div> -->
              <div class="column is-full">
                <admin-form-item label="팝업 노출기간">
                  <div class="flex" style="flex-wrap:wrap">
                    <admin-date-picker
                      :data="popup.start_date"
                      @setDate="selDateMin"></admin-date-picker>
                    <div class="lp-dating">&#126;</div>
                    <admin-date-picker
                      :data="popup.end_date"
                      @setDate="selDateMax"></admin-date-picker>
                  </div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>


      </div>
    </div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <div class="button is-primary" @click="saveData">저장하기</div>
    </div>

    <!--<sweet-modal ref="productListModal">
      <product-list @productItems="productItems" page="exhibition" :selectedItems="id_list"  style="zoom: 0.85"></product-list>
    </sweet-modal>-->
    <popup-preview v-if="preview" :popup="popup.imgs" @close="preview=false"></popup-preview>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import moment from "moment";
import BreadCrumb from "../../module/common/BreadCrumb";
import LpInputText from "../../module/common/LpInputText";
import LpRadio from "../../module/common/LpRadio";
import InputImg from "../../module/common/InputImg";
import LpAddress from "../../module/common/LpAddress";
import LpAdmDropInput from "../../module/common/LpAdmDropInput";
import LpCheckBool from "../../module/common/LpCheckBool";
import LpSortDropDown from "../../module/common/LpSortDropDown";
import ProductList from '../product/ProductList';
import { SweetModal } from 'sweet-modal-vue';
import PopupPreview from "../../module/common/PopupPreview";

export default {
  layout: "Main",
  components: {
    PopupPreview,
    LpInputText,
    draggable,
    LpRadio,
    InputImg,
    LpAddress,
    LpAdmDropInput,
    SweetModal,
    ProductList,
    LpCheckBool,
    LpSortDropDown
  },
  created() {
    /*this.nowTime=moment().format('YY-MM-DD');

    let start_year = parseInt(moment().format('YYYY'));
    let start_month = parseInt(moment().format('M'));
    let start_date = parseInt(moment().format('D'));

    let end_year = parseInt(moment().add(5, 'days').format('YYYY'));
    let end_month = parseInt(moment().add(5, 'days').format('M'));
    let end_date = parseInt(moment().add(5, 'days').format('D'));

    // this.popup.start_date = moment().format('YY-MM-DD');
    // this.popup.end_date = moment().add(5 ,'days').format('YY-MM-DD');
    this.popup.start_date = new Date (start_year, start_month-1, start_date);
    this.popup.end_date = new Date (end_year, end_month-1, end_date);
*/
    this.getData();
    this.ratio_desc = '팝업 이미지를 순서대로 업로드 해주세요. 이미지 비율은 3:4 입니다.'
  },
  data() {
    return {
      preview: false,
      nowTime: '',
      // 팝업 정보
      popup: {
        id: 0,
        // 팝업 등록일
        reg_date: '',
        // 기간별 노출여부 (노출여부display와 상관없이 모든 값 존재)
        // state가 true일 경우(상시노출일 경우)에만 end값이 '99-12-31 23:59:59'
        start_date:'',
        end_date:'',
        imgs: [''],
        links: [''],
        title: '',
        ratio: 0
      },
      ratioArr: [
        { label: '4:3', value: 0 },
        { label: '16:9', value: 1 },
        { label: '2.35:1', value: 2 },
        { label: '4:1', value: 3 }
      ],
      ratio_desc: ''
      // popup: {
      //   id: 82,
      //   // 팝업 등록일
      //   reg_date: '17-12-30 10:24:20',
      //   // 노출여부 (현재 노출할것인지)
      //   display: true,
      //   // 기간별 노출여부 (노출여부display와 상관없이 모든 값 존재)
      //   // state가 true일 경우(상시노출일 경우)에만 end값이 '99-12-31 23:59:59'
      //   displayAll: {
      //     state: true,   // true: 상시노출, false: 기간노출
      //     start: '18-01-02 12:00:00',
      //     end: '99-12-31 23:59:59'
      //   },
      //   type: '상품팝업',
      //   img: 'http://pds.joins.com/news/component/newsis/201308/06/NISI20130806_0008507689_web.jpg',
      //   title: '여름맞이 창고 대개방',
      //   description: '여름맞이 창고 대개방 최대 70%까지 할인 행사',
      //   count: 20
      // },
    }
  },
  watch: {
    'popup.ratio'(n) {
      //4:3 비율은 1920:1440, 16:9 비율은 1920:1080, 2.35:1 비율은 1920: 817, 4:1 비율은 1920:480
      if(n===0) this.ratio_desc = '4:3 비율 / 1920:1440'
      else if(n===1) this.ratio_desc = '16:9 비율 / 1920:1080'
      else if(n===2) this.ratio_desc = '2.35:1 비율 / 1920: 817'
      else if(n===3) this.ratio_desc = ' 4:1 비율 / 1920:480'
    }
    /*modalResponse(n){
      if(n==='close'){
        this.popup.products = n.productIdArr;
        this.productTable = n.productTable;
      }
    }*/
  },
  methods: {
    onDelete(idx) {
      removeIndex(this.popup.imgs, idx);
      removeIndex(this.popup.links, idx);
    },
    clickPreview() {
      this.preview = true;
    },
    addImg() {
      this.popup.imgs.push('');
      this.popup.links.push('');
    },
    linkValue(idx) {
      return this.popup.links[idx];
    },
    inputLink(e, idx) {
      this.popup.links[idx] = e.target.value;
    },
    imgField(img) {
      return 'background-image: url('+this.image(img)+');' +
        ' width: 60px; height: 60px; background-size: cover;' +
        ' background-position: center;';
    },
    // 팝업 등록 상품 검색
    openSelectProduct(){
      /*let value = {
        productTable: this.productTable,
        productIdArr: this.popup.products
      }
      this.$store.commit('openModal', {type: 'modal-select-exhibition-product', value: value, width: '1080'})*/
      this.$modal.show('productListModal');
    },
    deleteProductItem(idx){
      removeIndex(this.productTable,idx);
      removeIndex(this.popup.products,idx);
      removeIndex(this.id_list,idx);
    },
    selDateMin(date) {
      this.popup.start_date = date;
      // this.getData();
    },
    selDateMax(date) {
      this.popup.end_date = date;
      // this.getData();
    },
    saveData() {
      let err = '';
      if(!this.popup.title) {
        err = '팝업 제목을 입력해주세요.';
      }

      if(err) {
        this.toast(err);
        return;
      }

      let value = this.cloneItem(this.popup);
      if(!value.start_date){
        value.start_date = '1111-01-01';
      }
      if(!value.end_date){
        value.end_date = '9999-01-01';
      }
      if(this.$route.query.id){
        this.$axios.patch(this.getUrl('popup/')+this.$route.query.id, value).then(res=>{
          if(res.status===200){
            this.toast('저장되었습니다.');
            this.$router.replace(this.getPath('popup'));
          }
        })
      }
      else{
        this.$axios.post(this.getUrl('popup'), value).then(res=>{
          if(res.status===200){
            this.saveServiceGuide('popup');
            this.toast('저장되었습니다.');
            this.$router.replace(this.getPath('popup'));
          }
        })
      }
    },
    // 뒤로가기 (등록 취소)
    clickBack() {
      this.$router.back();
    },
    getData(){
      if(this.$route.query.id){
        this.$axios.get(this.getUrl('popup/'+this.$route.query.id)).then(res=>{
          if(res.status===200){
            this.popup = res.data;
            this.productTable = res.data.product_list;
            if(res.data.product_list) {
              for(let i=0; i<res.data.product_list.length; i++){
                this.id_list.push(res.data.product_list[i].id);
              }
            }
          }
        })
      }
    }
  }
};
</script>

<style lang="stylus" type="stylus" scoped>
////@import '~assets/css/reset';
@import '~assets/css/lp_variable';
//@import '~assets/css/lp_main';

.tr-whole-border th
  padding 12px 6px

.many-field-tr td
  padding 6px

.user-reg-basic-group-1 {
  width: 50%;
}

.user-reg-basic-group-2 {
  width: 50%;
  margin-top: 137px;
}

.user-reg-content-service {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.user-reg-service-group {
  width: 50%;
  padding-left: 20px;
  margin-bottom: 12px;
}

.user-reg-history-memo {
  width: 380px;
  height: 240px;
  margin: 0 10px;
  font-size: 0.9rem;
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ddd;
  border-radius: 3px;
  padding: 12px;
  overflow-y: auto;
}

.history-memo-item {
  width: 100%;
  margin-bottom: 12px;
}

.user-reg-history-btn {
  background-color: $primary;
  color: #fff;
  display: inline-block;
  padding: 8px 12px;
  margin-left: 8px;
  border-radius: 3px;
  cursor: pointer;
}

.prod-search-btn {
  font-size: 0.8rem;
  background: #e6e6e6;
  padding: 6px 12px;
  border-radius: 3px;
  display: inline-block;
  cursor: pointer;
}

.prod-tag
  background-color $point
  display inline-block
  padding 4px 10px
  color #fff
  border-radius 3px
  margin 2px

.prod-detail-content
  padding 20px
  font-size .95rem
  color #222
  border-radius 3px
  border none
  background-color #f2f7f8
  display block
  width 100%
  max-width 900px
  height 120px

.comment-sub-title
  background #ddd
  color #333
  padding 8px 16px
  font-size .95rem
  border-radius 3px
  display flex
  justify-content space-between

.description-text
  font-size 11px
  color #989898
  padding-bottom 12px
.btn-del
  cursor pointer
  margin-left 8px
</style>
